import { ReactElement } from 'react'
import { ProjectDetailsIndex } from 'src/screens/shared/project/details/ProjectDetailsIndex'

export const PfKapProjectDetailsIndexPage = (): ReactElement => {
  return <ProjectDetailsIndex baseUrl="/pf-kap" />
}
